import React from 'react';

export const Footer = () => {

    return(
        <footer className='h-8 bg-techvation text-center flex flex-col text-white text-[7pt]'>
            <div>&copy; {new Date().getFullYear()}</div>
            <a href="https://www.techvationsgroup.com">www.techvationsgroup.com</a>

        </footer>
    )

}